import { useProduct } from '../ProductProvider';
import { useGlobal } from '@/utils/useGlobal';
import { generalKeys } from '../config/page';
import { useEffect } from 'react';

export default function useProductMsg() {
    const { state, dispatch } = useProduct();
    const { gloproductlist } = useGlobal();

    useEffect(() => {
        if (state.productMsg && Object.keys(state.productMsg).length === generalKeys.length) return;

        let productMsgMap: any = {};
        generalKeys.forEach((generalKey: string) => {
            const target = gloproductlist?.find((item: any) => item.generalKey === generalKey);
            productMsgMap[generalKey] = target || {};
        });

        dispatch({
            type: 'changeProductMsg',
            payload: productMsgMap,
        });
    }, [state.productMsg, gloproductlist, dispatch]);
}
